<template>
  <div class="content-body">
    <div class="xinxi">
      <div class="title">
        查询条件
      </div>
      <!-- <el-date-picker size="small" v-model="value1" type="daterange" :value-format="'yyyy-MM-dd'" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      <el-button-group style="margin: 0 10px;">
        <el-button size="small" @click="selectDate(1)" :type="dateType === 1 && value1.length === 0 ? 'primary' : ''">今日</el-button>
        <el-button size="small" @click="selectDate(2)" :type="dateType === 2 && value1.length === 0 ? 'primary' : ''">本周</el-button>
        <el-button size="small" @click="selectDate(3)" :type="dateType === 3 && value1.length === 0 ? 'primary' : ''">本月</el-button>
      </el-button-group>
      <el-button size="small" type="primary" icon="el-icon-search" @click="drawLine()">查询</el-button>-->

      <el-select size="small" clearable v-model="plan_id" placeholder="计划" style="width: 120px; margin-right: 10px;">
        <el-option :label="item.title" :value="item.plan_id" v-for="(item, index) in planLists" :key="index"></el-option>
      </el-select>
      <el-select size="small" clearable v-model="group_id" placeholder="计划组" style="width: 120px; margin-right: 10px;">
        <el-option :label="item.group_name" :value="item.group_id" v-for="(item, index) in groupLists" :key="index"></el-option>
      </el-select>
      <el-select size="small" clearable v-model="adv_id" placeholder="创意" style="width: 120px; margin-right: 10px;">
        <el-option :label="item.adv_title" :value="item.adv_id" v-for="(item, index) in advLists" :key="index"></el-option>
      </el-select>
      <el-button-group style="margin: 0 10px;">
        <el-button size="small" @click="dateType = 1" :type="dateType === 1 ? 'primary' : ''">今日</el-button>
        <el-button size="small" @click="dateType = 2" :type="dateType === 2 ? 'primary' : ''">本周</el-button>
        <el-button size="small" @click="dateType = 3" :type="dateType === 3 ? 'primary' : ''">本月</el-button>
      </el-button-group>
      <el-button size="small" type="primary" icon="el-icon-search" @click="drawLine()">查询</el-button>
    </div>
    <div style="font-size: 12px; color: #666; padding-left: 4px; font-weight: 400;">省级地域分布</div>
    <div style="display: flex;">

      <div style="width: 38%; border: 1px solid #ccc; padding: 20px; border-radius: 5px;">
        <div id="myChart" :style="{width: '100%', height: '300px', marginLeft: '10px', marginTop: '10px'}"></div>
      </div>
      <div style="display: flex; margin-left: 2%; width: 28%; border: 1px solid #ccc; padding: 20px; border-radius: 5px;">
        <div style="width:90px; font-weight: bold; color: 333;">性别分布</div>
        <div id="echarts-os" :style="{width: '100%', height: '300px', marginTop: '10px'}"></div>
      </div>
      <div style="display: flex; margin-left: 2%; width: 28%; border: 1px solid #ccc; padding: 20px; border-radius: 5px;">
        <div style="width:90px; font-weight: bold; color: 333;">年龄分布</div>
        <div id="echarts-device_price" :style="{width: '100%', height: '300px', marginTop: '10px'}"></div>
      </div>
    </div>
    <div style="font-size: 12px; color: #666; padding-left: 4px; font-weight: 400; margin-top: 30px;">Top20省级分布</div>
    <div class="city-body" style="border: 1px solid #ccc; border-radius: 5px;">
      <div id="echarts-device_city" :style="{width: '100%', height: '600px', marginTop: '10px'}"></div>
    </div>
    <div style="display: flex; margin-top: 60px; justify-content: center;">

    </div>
  </div>
</template>
<script>
import echarts from 'echarts';
import 'echarts/lib/chart/map';
import 'echarts/map/js/china.js';
export default {
  data() {
    return {
      value1: [],
      dateType: 1,
      plan_id: '',
      planLists: [],
      group_id: '',
      groupLists: [],
      adv_id: '',
      advLists: []
    };
  },
  mounted() {
    this.$http.post('/trader/index/group_form').then(res => {
      if (res.code === 200) {
        this.planLists = res.data.plan_lists;
        this.drawLine();
        this.$function.hiddenLoading();
      }
    });
    // this.drawLine();
    // setTimeout(() => {

    // }, 200);
  },
  methods: {
    drawLine() {
      let dateType = this.dateType;
      if (this.value1.length > 0) {
        dateType = this.value1.join(',');
      }
      this.$http.post('/trader/data/getAddressCount', {
        dateType,
        creativeId: this.adv_id,
        groupId: this.group_id,
        planId: this.plan_id
      }).then(result => {
        if (result.code === 200) {
          console.log(result);
          const res = result.result;
          const area = res.areaJson;
          const area2 = res.area2Json;

          const builderJson = {
            charts: {},
            components: {}
          };

          for (let i = 0; i < area2.length; i++) {
            builderJson.charts[area2[i].name] = area2[i].value;
          }

          var waterMarkText = 'bilibili';

          var canvas = document.createElement('canvas');
          var ctx = canvas.getContext('2d');
          canvas.width = canvas.height = 100;
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.globalAlpha = 0.08;
          ctx.font = '20px Microsoft Yahei';
          ctx.translate(50, 50);
          ctx.rotate(-Math.PI / 4);
          ctx.fillText(waterMarkText, 0, 0);

          const option = {
            title: {
              text: '地域分布'
            },
            tooltip: {
              formatter: function(params, ticket, callback) {
                return params.seriesName + '<br />' + params.name + '：' + params.value;
              }// 数据格式化
            },
            visualMap: {
              min: 0,
              max: 1500,
              left: 'left',
              top: 'bottom',
              text: ['高', '低'], // 取值范围的文字
              inRange: {
                color: ['#e0ffff', '#0056AF']// 取值范围的颜色
              },
              show: true// 图注
            },
            geo: {
              map: 'china',
              roam: false, // 不开启缩放和平移
              zoom: 1.23, // 视角缩放比例
              label: {
                normal: {
                  show: true,
                  fontSize: '10',
                  color: 'rgba(0,0,0,0.7)'
                }
              },
              itemStyle: {
                normal: {
                  borderColor: 'rgba(0, 0, 0, 0.2)'
                },
                emphasis: {
                  areaColor: '#F3B329', // 鼠标选择区域颜色
                  shadowOffsetX: 0,
                  shadowOffsetY: 0,
                  shadowBlur: 20,
                  borderWidth: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            },
            series: [
              {
                name: '信息量',
                type: 'map',
                geoIndex: 0,
                data: area
              }
            ]
          };
          const echartsRecords = echarts.init(document.getElementById('myChart'));
          echartsRecords.setOption(option);

          // 性别分布
          const options_demo5 = {
            color:['#95BDFF', '#FF9BC0', '#E1E3EE'],
            tooltip: {
                trigger: 'item',
                formatter: '{a} <br/>{b}: {c} ({d}%)'
            },
            legend: {
                orient: 'vertical',
                left: 10,
                data: ['男', '女', '未知']
            },
            series: [
              {
                name: '访问来源',
                type: 'pie',
                radius: ['50%', '70%'],
                avoidLabelOverlap: false,
                label: {
                  show: false,
                  position: 'center'
                },
                emphasis: {
                    label: {
                      show: true,
                      fontSize: '30',
                      fontWeight: 'bold',
                    }
                },
                labelLine: {
                    show: true
                },
                data: [
                    {value: res.devicePriceJson[0], name: '男'},
                    {value: res.devicePriceJson[1], name: '女'},
                    {value: res.devicePriceJson[2], name: '未知'}
                ],
              }
            ]
          };

          const demo5 = echarts.init(document.getElementById('echarts-os'), 'walden');
          demo5.setOption(options_demo5);

          // 年龄分布
          const options_demo6 = {
            color:['#3436C7', '#F04864', '#8543E0', '#1890FF', '#13C2C2', '#2FC25B'],
            tooltip: {
                trigger: 'item',
                formatter: '{a} <br/>{b}: {c} ({d}%)'
            },
            legend: {
                orient: 'vertical',
                left: 10,
                data: ['<18', '18-24', '25-34', '35-44', '45-54', '>55']
            },
            series: [
              {
                name: '访问来源',
                type: 'pie',
                radius: ['50%', '70%'],
                avoidLabelOverlap: false,
                label: {
                  show: false,
                  position: 'center'
                },
                emphasis: {
                    label: {
                      show: true,
                      fontSize: '30',
                      fontWeight: 'bold',
                    }
                },
                labelLine: {
                    show: true
                },
                data: [
                    {value: res.operateSystemJson[0], name: '<18'},
                    {value: res.operateSystemJson[1], name: '18-24'},
                    {value: res.operateSystemJson[2], name: '25-34'},
                    {value: res.operateSystemJson[3], name: '35-44'},
                    {value: res.operateSystemJson[4], name: '45-54'},
                    {value: res.operateSystemJson[5], name: '>55'},
                ],
              }
            ]
          };

          const demo6 = echarts.init(document.getElementById('echarts-device_price'), 'walden');
          demo6.setOption(options_demo6);

          const options_demo7 = {
            color: ['#3398DB'],
            tooltip: {
              trigger: 'axis',
              axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                  type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
              }
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            xAxis: [
              {
                type: 'category',
                data: res.cityLists,
                axisTick: {
                    alignWithLabel: true
                }
              }
            ],
            yAxis: [
              {
                type: 'value'
              }
            ],
            series: [
              {
                name: '直接访问',
                type: 'bar',
                barWidth: '60%',
                data: res.lineCityValue
              }
            ]
          }
          const demo7 = echarts.init(document.getElementById('echarts-device_city'), 'walden');
          demo7.setOption(options_demo7);
        }
      });
    },
    selectDate(dateType) {
      this.value1 = [];
      this.dateType = dateType;
    }
  },
  watch: {
    plan_id(newVal, oldVal) {
      this.$http.post('/trader/index/getGroupForPlanId', {
        plan_id: newVal
      }).then(res => {
        if (res.code === 200) {
          this.groupLists = res.data.group_lists;
          this.group_id = '';
          this.adv_id = '';
        }
      });
    },
    group_id(newVal, oldVal) {
      if (newVal !== '') {
        this.$http.post('/trader/data/getAdvLists', {
          group_id: newVal
        }).then(res => {
          if (res.code === 200) {
            this.advLists = res.data;
            this.adv_id = '';
          }
        });
      }
    }
  }
};
</script>
<style lang="less" scoped="">
  .xinxi {
    width: 100%;
    padding-bottom: 25px;
    .title {
      display: flex;
      align-items: center;
      font-size: 18px;
      color: #221815;
      padding: 10px 0;
      margin-bottom: 10px;
      img {
        width: 18px;
        height: 18px;
        margin-right: 10px;
      }
    }
  }
  .other-data {
    display: flex;
    padding: 10px;
    .ios, .andriod {
      width: 50%;
    }
  }
</style>
